import { Grid, useTheme, useMediaQuery, Button } from "@mui/material";
import { GenericCard } from "src/general_components/GenericCard";
import { useState } from "react";
import { ListTablePaginated } from "src/general_components/ListTablePaginated";
import {
  deleteEstadosCajas,
  getEstadosCajas,
  getEstadosCajasPaginated,
} from "../helpers/EstadosCajasData";
import { EstadosCajasForm } from "./EstadosCajasForm";
import { postEstadosCajas } from "../helpers/EstadosCajasData";
import { CajasProvider } from "src/context/CajasContext/CajasContext";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

export const EstadosCajasList = () => {
  const [estadosCajasSeleccionado, setEstadosCajasSeleccionado] = useState([]);
  const [createButton, setCreateButton] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const columns = [
    { field: "id", headerName: "ID", flex: 0.3 }, // la propiedad flex permite setear responsivamente el tamaño de la columna
    { field: "detalle", headerName: "Detalle", flex: 1 }, // la misma se divide entre el total y el porcentaje que le asiganas con un numero
  ];

  const listName = "Estado de Cajas";

  const handleDelete = async (id) => {
    const success = await deleteEstadosCajas(id);
    if (success) {
      window.location.reload();
    }
  };

  const mobileComponent = ({ row }) => (
    <GenericCard
      row={row}
      columns={columns}
      onEdit={(item) => {
        setEstadosCajasSeleccionado(item);
        setCreateButton(true);
      }}
      onDelete={handleDelete}
    />
  );

  const [options, setOptions] = useState({
    cols: columns,
    get: getEstadosCajas,
    getPaginated: getEstadosCajasPaginated,
    pageSize: [5, 10, 25],
    edit: true,
    delete: deleteEstadosCajas,
    limit: 50,
    filter: true,
    exportData: true,
    server: true,

    //DATOS PARA EL FORMULARIO
    createButton: createButton,
    setCreateButton: setCreateButton,
    setDataEdit: setEstadosCajasSeleccionado,

    mobileComponent: mobileComponent,
  });

  //CONTROLA CUANDO SE SALE DE UN EDITAR PARA LIMPIAR LA VARIABLE, GUARDA CON EL ID, PUEDE SER QUE EN ALGUNOS NO FUNCIONE
  //TODOS LOS EDITAR DEBERIAN DE TENER UN ID, PERO POR LAS DUDAS COMPROBAR.
  if (createButton === false && estadosCajasSeleccionado.id !== undefined) {
    setEstadosCajasSeleccionado([]);
  }

  const mobileTopButtons = isMobile && (
    <Grid container justifyContent="flex-end" mb={2} mt={1}>
      <Grid item xs={12} sm={6}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={() => { setCreateButton(true); setEstadosCajasSeleccionado([]); }}
          style={{ fontSize: "11px", height: "30px", fontFamily: 'Roboto, sans-serif', color: '#FFFFFF' }}
        >
          Añadir Estado
        </Button>
      </Grid>
    </Grid>
  );

  return (


    <Grid style={{ marginBottom: "50px", backgroundc: "rgb(241, 243, 244)", paddingTop: 10 }}>
      <PageHeaderCard title={listName} icon={<CheckBoxIcon />} />
      {mobileTopButtons}
      <CajasProvider>
        <>

          <ListTablePaginated options={options} />
          <EstadosCajasForm
            data={estadosCajasSeleccionado}
            createButton={createButton}
            listName={listName}
            setCreateButton={setCreateButton}
            componentList={"/estado_cajas/admin"}
            postData={postEstadosCajas}
            setOptions={setOptions}
            options={options}
          />
        </>
      </CajasProvider>
    </Grid>


  );
};
